export default {"src":"/_next/static/media/WPLTitle.952e5aaf.svg","height":128,"width":126};